










import VueOptions from '@utils/VueOptions'
import Editor from '@/components/Editor'

settings =
  name: 'FormFieldEditor'

  vue:
    props: ['value', 'errors', 'placeholder']

    components: {
      Editor,
    }

    data: ->
      text: @value

    methods:
      hiInputChange: (value) ->
        @$emit 'input', value

    watch:
      value: (v) ->
        @text = v

export default VueOptions.vue settings
